export const ATIVOS_BASIC_SORT_OPTIONS = [
  { label: 'Relevância', value: '' },
  { label: 'Nome do ativo (A-Z)', value: 'ativo ASC' },
  { label: 'Nome do ativo (Z-A)', value: 'ativo DESC' }
];

export const ATIVOS_FIXED_INCOME_SORT_OPTIONS = [
  ...ATIVOS_BASIC_SORT_OPTIONS,
  { label: 'Vencimento mais próximo', value: 'vencimento ASC' },
  { label: 'Vencimento mais distante', value: 'vencimento DESC' }
];

export const ATIVOS_FUND_SORT_GROUPS = [
  {
    id: 'geral',
    label: 'Geral',
    options: [...ATIVOS_BASIC_SORT_OPTIONS]
  },
  {
    id: 'custos-condicoes',
    label: 'Custos e condições',
    options: [
      { label: 'Maior taxa de administração', value: 'taxa_adm DESC' },
      { label: 'Menor taxa de administração', value: 'taxa_adm ASC' },
      { label: 'Maior aplicação mínima', value: 'aplicacao_min DESC' },
      { label: 'Menor aplicação mínima', value: 'aplicacao_min ASC' },
      { label: 'Maior prazo para resgate', value: 'resgate_carencia DESC' },
      { label: 'Menor prazo para resgate', value: 'resgate_carencia ASC' }
    ]
  },
  {
    id: 'desempenho-risco',
    label: 'Desempenho e risco',
    options: [
      { label: 'Maior retorno', value: 'retorno DESC' },
      { label: 'Menor retorno', value: 'retorno ASC' },
      {
        label: 'Maior percentual de dias acima do benchmark',
        value: 'perc_dias_acima_benchmark DESC'
      },
      {
        label: 'Menor percentual de dias acima do benchmark',
        value: 'perc_dias_acima_benchmark ASC'
      },
      {
        label: 'Maior percentual de meses acima do benchmark',
        value: 'perc_meses_acima_benchmark DESC'
      },
      {
        label: 'Menor percentual de meses acima do benchmark',
        value: 'perc_meses_acima_benchmark ASC'
      },
      { label: 'Maior Sharpe', value: 'sharpe DESC' },
      { label: 'Menor Sharpe', value: 'sharpe ASC' },
      { label: 'Maior tracking error', value: 'tracking_error DESC' },
      { label: 'Menor tracking error', value: 'tracking_error ASC' },
      { label: 'Maior volatilidade', value: 'volatilidade DESC' },
      { label: 'Menor volatilidade', value: 'volatilidade ASC' }
    ]
  },
  {
    id: 'patrimonio-cotistas',
    label: 'Patrimônio e cotistas',
    groups: [
      {
        id: 'fundo',
        label: 'Fundo',
        options: [
          {
            label: 'Maior patrimônio líquido',
            selectedLabel: 'Fundo — maior patrimônio líquido',
            value: 'pl DESC'
          },
          {
            label: 'Menor patrimônio líquido',
            selectedLabel: 'Fundo — menor patrimônio líquido',
            value: 'pl ASC'
          },
          {
            label: 'Maior número de cotistas',
            selectedLabel: 'Fundo — maior número de cotistas',
            value: 'cotistas DESC'
          },
          {
            label: 'Menor número de cotistas',
            selectedLabel: 'Fundo — menor número de cotistas',
            value: 'cotistas ASC'
          }
        ]
      },
      {
        id: 'gestor',
        label: 'Gestor',
        options: [
          {
            label: 'Maior patrimônio líquido',
            selectedLabel: 'Gestor — maior patrimônio líquido',
            value: 'gestor_pl DESC'
          },
          {
            label: 'Menor patrimônio líquido',
            selectedLabel: 'Gestor — menor patrimônio líquido',
            value: 'gestor_pl ASC'
          },
          {
            label: 'Maior número de cotistas',
            selectedLabel: 'Gestor — maior número de cotistas',
            value: 'gestor_cotistas DESC'
          },
          {
            label: 'Menor número de cotistas',
            selectedLabel: 'Gestor — menor número de cotistas',
            value: 'gestor_cotistas ASC'
          }
        ]
      },
      {
        id: 'administrador',
        label: 'Administrador',
        options: [
          {
            label: 'Maior patrimônio líquido',
            selectedLabel: 'Administrador — maior patrimônio líquido',
            value: 'adm_pl DESC'
          },
          {
            label: 'Menor patrimônio líquido',
            selectedLabel: 'Administrador — menor patrimônio líquido',
            value: 'adm_pl ASC'
          },
          {
            label: 'Maior número de cotistas',
            selectedLabel: 'Administrador — maior número de cotistas',
            value: 'adm_cotistas DESC'
          },
          {
            label: 'Menor número de cotistas',
            selectedLabel: 'Administrador — menor número de cotistas',
            value: 'adm_cotistas ASC'
          }
        ]
      }
    ]
  }
];

/** Converte a hierarquia visual em uma lista única para seleção e validação. */
function pvFlattenSortGroups(pGroups) {
  return pGroups.reduce(
    (pOptions, pGroup) => [
      ...pOptions,
      ...(pGroup.options || []),
      ...pvFlattenSortGroups(pGroup.groups || [])
    ],
    []
  );
}

export const ATIVOS_FUND_SORT_OPTIONS = pvFlattenSortGroups(ATIVOS_FUND_SORT_GROUPS);

export default {
  ATIVOS_BASIC_SORT_OPTIONS,
  ATIVOS_FIXED_INCOME_SORT_OPTIONS,
  ATIVOS_FUND_SORT_GROUPS,
  ATIVOS_FUND_SORT_OPTIONS
};
